import React, {Fragment, useState} from "react";
import {CircularProgress, Dialog} from "@mui/material";
import {Close} from "@mui/icons-material";
import UnservicedZip from "./UnservicedZip";
import EnterZip from "./EnterZip";
import {useLocation, useSearchParams} from "react-router-dom";
import {mergeSearchParams, redirectSkiptiCheckoutFlow} from "../../helpers";
import {useOrganization} from "../../store/organization";
import {modalTypes, useOrderDetail} from "../../store/orderDetail";
import {PARTNERS, QUERY_PARAMS} from "../../utils/constants";
import EnterDetail from "./EnterDetail";

export const Steps = (props) => {
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const [dialogDisplay, setDialogDisplay] = useState("block");

  const {data: organizationData, isLoading} = useOrganization(
    (state) => state.organization
  );
  const {modalType, updateFields} = useOrderDetail();

  const updateZipInformation = (zipValue, zipData) => {
    if (zipData?.serviced) {
      const pathnameArray = location.pathname.split("/");

      const clientParam = searchParams.get(QUERY_PARAMS.CLIENT);
      const zipParam = searchParams.get(QUERY_PARAMS.ZIP);
      const storeIdParam = searchParams.get(QUERY_PARAMS.STORE_ID)

      const clientString = clientParam ? "" : `client=${PARTNERS.HOME_DEPOT}`;
      const zipString = zipParam ? "" : `zip=${zipValue}`;
      const storeId = storeIdParam ? `storeId=${storeIdParam}` : "";

      let params = mergeSearchParams(location.search, [
        zipString,
        clientString,
        storeId
      ]);

      let productId = zipData?.skiptiProductId;
      let redirectionPath = `/${pathnameArray[1]}/${pathnameArray[2]}/${productId}`;

      if (!productId) {
        if (zipData?.hasAlternate) {
          // Should go to the alternate product show page
          productId = zipData?.skiptiAlternateId;

          redirectionPath = `/items/${productId}`;
          params += "&alternative=true";
        } else {
          // Should go to the partner page
          redirectionPath = `/partners/${
            clientParam || PARTNERS.HOME_DEPOT
          }?alternative=false&`;
          params = zipString;
        }
      }

      // Redirect to the original product show page
      return redirectSkiptiCheckoutFlow(redirectionPath, params);
    }

    updateFields({
      zip: zipValue,
      modalType: modalType.UNSERVICED_ZIP,
    });
  };

  return (
    <Dialog
      onClose={undefined}
      maxWidth="xs"
      fullWidth
      open={true}
      sx={{"&": {display: dialogDisplay}, ".MuiPaper-root": {overflowX: "hidden"}}}
    >
      {/* <div className="tw-flex tw-justify-end tw-pt-4 tw-pr-4">
        <Close/>
      </div> */}
      <div className="tw-flex tw-justify-end tw-pt-4 tw-pr-4" />

      {isLoading ? (
        <div className="tw-h-20 tw-flex tw-justify-center">
          <CircularProgress color="inherit" size={40}/>
        </div>
      ) : (
        organizationData && (
          <Fragment>
            <div className="tw-w-full">
              <div className="tw-flex tw-justify-center">
                <img
                  className="tw-w-1/2"
                  alt="skipti-partner-logos"
                  src={organizationData?.popupLogo}
                />
              </div>
            </div>

            {searchParams.get(QUERY_PARAMS.NON_SKIPTI_INVENTORY) ? (
              <EnterDetail />
            ) : modalType === modalTypes.ENTER_ZIP ? (
              <EnterZip updateZipInformation={updateZipInformation} toggleDialog={setDialogDisplay}/>
            ) : (
              <UnservicedZip />
            )}
          </Fragment>
        )
      )}
    </Dialog>
  );
};

Steps.propTypes = {};
